import { useMatches } from 'react-router-dom'
import { PageAccess } from 'src/routes/routes-behind-login/routes-behind-login'

export function useHasPageExternalAccess() {
  const matches = useMatches()
  return matches.every(
    // @ts-ignore
    (x) => x.handle?.pageAccess !== PageAccess.INTERNAL,
  )
}
